import { useEffect, useRef, useState } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { Card, Row, Switch, Typography } from 'antd'
import { Check, Edit, X } from 'react-feather'
import { setDarkModeEnabled } from 'Actions/explore'

{ Paragraph, Text } = Typography


helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph>
    Choose from dark or light theme.
  </Paragraph>
</div>)


ThemePanel = ({ darkMode, setDarkModeEnabled }) ->

  <Card
    title="Theme"
    size="small"
    id="theme"
  >
    <Row>
      <Switch
        style={{ marginRight: 5 }}
        onChange={(checked) ->
          setDarkModeEnabled(checked)
          localStorage.setItem('theme', checked && 'theme-dark' || 'theme-light')
        }
        checked={darkMode}
        checkedChildren="Dark mode"
        unCheckedChildren="Light mode"
      />
      wvr.io theme
    </Row>
  </Card>

export default connect(({ explore }) ->
  { darkMode: explore.darkModeEnabled }
, { setDarkModeEnabled })(ThemePanel)
